import React, { useContext, useEffect, useState } from "react";
import { Checkbox } from "@mantine/core";
import axios from "axios";
import { AppContext, TOGGLE_OPTIN } from "../../context";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

/*
 * Note to future self:
 * Links are not rendering correctly if using html, which is a must if you want't to use target="_blank"-links.
 * Workaround available here: https://github.com/remarkjs/react-markdown/issues/99 (wrap with <p></p>).
 */

let source;

const OptIn = () => {
  const { state, dispatch } = useContext(AppContext);
  const { config, hasOptedIn, culture, posId } = state;
  const [text, setText] = useState();

  useEffect(() => {
    let CancelToken = axios.CancelToken;
    source = CancelToken.source();
    axios
      .get(
        `${config.baseUrl}/ee-static/checkout/pos-${posId}/Texts/optin.${culture}.md`,
        {
          cancelToken: source.token,
        }
      )
      .then((r) => setText(r.data))
      .catch((e) => console.error(e));
    return () => source.cancel("OptIn Is Unmounting");
  }, [culture, posId]);

  const toggleOptIn = () => {
    dispatch({ type: TOGGLE_OPTIN });
  };

  return (
    <Checkbox
      label={
        <ReactMarkdown className="optin__text" rehypePlugins={[rehypeRaw]}>
          {text}
        </ReactMarkdown>
      }
      onChange={() => toggleOptIn()}
      checked={hasOptedIn}
      pt={12}
      pb={12}
      styles={{ input: { border: "1px solid black" } }}
    />
  );
};

export default OptIn;
